<template>
	<div>
		<div class="f-regular f-12 f-c-midgrey">
			<img src="../../../../../assets/icon-sidebar/outlet-sidebar.svg" alt=""
			     class="m-r-4"
			     style="height: 13px; margin-top: -2px"
			/>
			{{ snapTransaksi.nama_outlet }}
		</div>
		<div>
			<span class="f-semi f-16 f-c-black">{{ snapTransaksi.idtransaksi }}</span>
			<span class="f-regular f-14 f-c-midgrey m-l-4">
				({{ snapTransaksi.jenis === 2 ? 'Drop Off' : 'Self Service' }})
			</span>
		</div>

		<div class="f-regular f-13 f-c-midgrey" v-if="snapTransaksi.jenis === 2">
			Dibuat oleh <span class="f-c-black"> {{ snapTransaksi.nama_karyawan }}</span>
		</div>
	</div>
</template>

<script>
import SOProgressBar from "@/so-components/global/ui/SOProgressBar";

export default {
	name: "SOTransaksiSnapcleanDetailTipe",
	components: {
		SOProgressBar,
	},
	props: {
		snapTransaksi: Object
	},
}
</script>